import { useQuery } from '@tanstack/react-query';
import MetadataService from '../../service/MetadataService';

export const useUpdateLog = (workspace) => {
  return useQuery({
    queryKey: ['update-log', workspace],
    queryFn: () => MetadataService.sharedInstance().getStateUpdateLog(workspace),
    enabled: !!workspace,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
